export const SHOW_NOTIFICATION = "notification/SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "notification/HIDE_NOTIFICATION";